import { useFetchContent } from 'app/content/hooks';
import { ProductsTemplate, PtgFeaturesTemplate } from '../index.js';
import { get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { PTG_FEATURES_TEMPLATE_ID } from '../PtgFeaturesTemplate';
import { PRODUCTS_TEMPLATE_ID } from '../ProductsTemplate';
import { useDetermineEFlyerThemeApplication } from '../eflyer-utils.js';
import { NotFound } from 'app/layout/components';

const EFlyerResolver = props => {
  const { location } = props;
  const [content, setContent] = useState(null);
  const themeApplication = useDetermineEFlyerThemeApplication();

  const eflyerPath = '/eflyer';
  const pdfPath = '/pdf';
  const pathname = location.pathname;

  let contentPath = stripPathSegment(pathname, eflyerPath);
  contentPath = stripPathSegment(contentPath, pdfPath);

  const contentResponse = useFetchContent({ uri: contentPath });

  useEffect(() => {
    if (contentResponse) {
      setContent(contentResponse);
    }
  }, [contentResponse]);

  if (isEmpty(content)) {
    return <div>Loading...</div>;
  }

  const modelId = get(content, 'model.id', null);
  if (!modelId) {
    return <NotFound />;
  }
  if (modelId === PRODUCTS_TEMPLATE_ID) {
    return (
      <ProductsTemplate
        content={contentResponse}
        themeApplication={themeApplication}
      />
    );
  } else if (modelId === PTG_FEATURES_TEMPLATE_ID) {
    return (
      <PtgFeaturesTemplate
        content={contentResponse}
        themeApplication={themeApplication}
      />
    );
  }
};

function stripPathSegment(path, segment) {
  return path.startsWith(segment) ? path.substring(segment.length) : path;
}

export default EFlyerResolver;
export { EFlyerResolver };
